import { cn } from "@/lib/chillnn/cn";

import { TableCell, TableRow } from "@/components/ui/table/table";

type Props = {
	itemName: string;
	itemEditPagePath: string;

	itemLabelChildren: React.ReactNode;

	stockDailyItemChildren: React.ReactNode;
};

export const StockTableRow = ({ itemName, itemEditPagePath, itemLabelChildren, stockDailyItemChildren }: Props) => {
	return (
		<TableRow className={cn("max-h-32 border-t border-t-zinc-200")}>
			{/* アイテム名 */}
			<TableCell
				className="sticky left-0 z-30 block h-32 max-h-32 border-r border-r-zinc-200 bg-white text-left text-zinc-950"
				zeroPadding
			>
				<div className="flex h-full gap-2">
					{/* アイテム名 & ラベル */}
					<div className="flex w-3/4 flex-col p-2 has-[span]:gap-y-4">
						<div className="flex flex-wrap gap-x-2 gap-y-1">{itemLabelChildren}</div>

						<a href={itemEditPagePath}>
							<p className="line-clamp-3 text-sm hover:underline">{itemName}</p>
						</a>
					</div>
					{/* 表示する情報のタイトル */}
					{/* 表示する情報のスタイルとデザイン上の依存関係がある */}
					<div className="w-1/4 space-y-3 py-3 text-xs font-normal">
						<p className="flex h-10 items-center">残在庫</p>
						<p className="h-5">販売数</p>
					</div>
				</div>
			</TableCell>

			{/* アイテム詳細（在庫など） */}
			{stockDailyItemChildren}
		</TableRow>
	);
};
